import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

export const LazyHomePage = lazy(
  () => import(/* webpackChunkName: 'HomePage' */ './index'),
);

export default function HomePage() {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyHomePage />
    </Suspense>
  );
}
